// src/OffsetsPlaceholder2026.js
import React from 'react';

export default function OffsetsPlaceholder2026() {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a3327 0%, #0f2419 100%)',
      padding: '32px',
      borderRadius: '12px',
      border: '2px solid #2d5a45',
      textAlign: 'center'
    }}>
      <span style={{ fontSize: '48px', display: 'block', marginBottom: '16px' }}>🌱</span>
      
      <h2 style={{ 
        color: '#4ade80', 
        margin: '0 0 12px 0',
        fontSize: '24px'
      }}>
        Carbon Offsets Coming in 2026
      </h2>
      
      <p style={{ 
        color: '#888', 
        maxWidth: '600px', 
        margin: '0 auto 24px auto',
        lineHeight: '1.6'
      }}>
        We're building the infrastructure to connect your regenerative farming practices 
        to verified carbon credit markets. Track A farmers with GPS-verified plots will 
        be eligible for carbon offset payments starting in 2026.
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        <div style={{
          background: '#0f2419',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #2d5a45'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>📍</div>
          <div style={{ color: '#4ade80', fontWeight: 'bold', marginBottom: '4px' }}>
            GPS Verification
          </div>
          <div style={{ color: '#666', fontSize: '13px' }}>
            Track A farmers need GPS-verified plots
          </div>
        </div>

        <div style={{
          background: '#0f2419',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #2d5a45'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🧪</div>
          <div style={{ color: '#4ade80', fontWeight: 'bold', marginBottom: '4px' }}>
            Soil Sampling
          </div>
          <div style={{ color: '#666', fontSize: '13px' }}>
            Regular soil samples to measure carbon
          </div>
        </div>

        <div style={{
          background: '#0f2419',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #2d5a45'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>✅</div>
          <div style={{ color: '#4ade80', fontWeight: 'bold', marginBottom: '4px' }}>
            Third-Party Verification
          </div>
          <div style={{ color: '#666', fontSize: '13px' }}>
            Independent verification of credits
          </div>
        </div>

        <div style={{
          background: '#0f2419',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #2d5a45'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>💰</div>
          <div style={{ color: '#4ade80', fontWeight: 'bold', marginBottom: '4px' }}>
            Carbon Payments
          </div>
          <div style={{ color: '#666', fontSize: '13px' }}>
            Direct payments to verified farmers
          </div>
        </div>
      </div>

      <div style={{
        marginTop: '24px',
        padding: '16px',
        background: '#0f2419',
        borderRadius: '8px',
        border: '1px solid #fbbf24'
      }}>
        <p style={{ color: '#fbbf24', margin: 0, fontSize: '14px' }}>
          💡 <strong>Get ready now:</strong> Complete your farmer profile, register your plots with GPS, 
          and start submitting soil samples to be first in line for carbon payments.
        </p>
      </div>
    </div>
  );
}
















































































































